import { debug } from './debug';
import { isTopicsSupportAvailable } from '../analytics/topics';

export interface HttpError {
  code: number | undefined;
  message: string | undefined;
}

export interface HttpResponse<T> {
  data: T | undefined;
  error: HttpError | undefined;
}

export const makeGetRequest = async <T>(
  url: string,
  apiKey: string,
  loadId: string
): Promise<HttpResponse<T>> => {
  try {
    let error;
    const request = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Edkt-Load-Id': loadId,
        'X-Edkt-Api-Key': apiKey,
      },
      ...(isTopicsSupportAvailable() ? { browsingTopics: true } : {}),
    };
    const response = await fetch(url, request);
    if (!response.ok) {
      error = { code: response.status, message: response.statusText };
    }
    const data = await response.json();
    return { error, data };
  } catch (err) {
    debug('GET Error:', err);
    return {
      error: { code: undefined, message: String(err) },
      data: undefined,
    };
  }
};

export const makePostRequest = async <T>(
  url: string,
  body: string,
  apiKey: string,
  loadId: string
): Promise<HttpResponse<T>> => {
  try {
    let error;
    const request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Edkt-Load-Id': loadId,
        'X-Edkt-Api-Key': apiKey,
      },
      body,
      ...(isTopicsSupportAvailable() ? { browsingTopics: true } : {}),
    };
    const response = await fetch(url, request);
    if (!response.ok) {
      error = { code: response.status, message: response.statusText };
    }
    const data = await response.json();
    return { error, data };
  } catch (err) {
    debug('POST Error:', err);
    return {
      error: { code: undefined, message: String(err) },
      data: undefined,
    };
  }
};

export const sendBeacon = (url: string, body: string): void => {
  try {
    navigator.sendBeacon(url, body);
  } catch (err) {
    debug('Beacon Error:', err);
  }
};
